import { Queue } from 'lib-shared-types-api';
import { useMemo } from 'react';

import type { OptionT } from 'components/powerFlowShared/components/types';
import type {
  ChatExtraData,
  EmailExtraData,
  MessengerExtraData,
  PhoneExtraData,
} from 'fable/flowEditor/components/flowManager/canvas/types/extraData';

export const useFindQueue = <
  TExtraData extends
    | PhoneExtraData
    | EmailExtraData
    | MessengerExtraData
    | ChatExtraData,
>(
  payload: OptionT | null,
  extraData: TExtraData,
): Queue | undefined => {
  const { queues } = extraData;
  const { value: queueId } = payload ?? {};

  return useMemo(
    () => queues.find((queue) => queue.id === queueId),
    [queueId, queues],
  );
};
